var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tabs"},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.number,class:{active: tab.routeName === _vm.$route.name}},[_c('span',{domProps:{"textContent":_vm._s(tab.number + '／')}}),_vm._v(_vm._s(tab.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }